import { render, staticRenderFns } from "./ProfileEntry.vue?vue&type=template&id=8b700ece&scoped=true&"
import script from "./ProfileEntry.vue?vue&type=script&lang=ts&"
export * from "./ProfileEntry.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileEntry.vue?vue&type=style&index=0&id=8b700ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b700ece",
  null
  
)

export default component.exports